import React from 'react'
import { Entity } from 'draft-js'
import { convertToHTML, convertFromHTML } from 'draft-convert'

const toHTML = styleMap => convertToHTML({
  styleToHTML(style) {
    if (styleMap[style]) {
      return <span style={styleMap[style]}/>
    }
  },
  blockToHTML(block) {
    if (block.text) {
      return <p />
    } else {
      return <p><br /></p>
    }
  },
  entityToHTML(entity, originalText) {
    if (entity.type === 'LINK') {
      return <a href={entity.data.url}>{originalText}</a>
    }
    return originalText
  }
})

const fromHTML = styleMap => convertFromHTML({
  htmlToStyle(nodeName, node, currentStyle) {
    if (nodeName === 'span') {
      return Object.keys(styleMap).reduce((currentStyle, style) => {
        const hasStyle = !Object.keys(styleMap[style]).find(prop => {
          return styleMap[style][prop] !== node.style[prop]
        })
        if (hasStyle) {
          return currentStyle.add(style)
        } else {
          return currentStyle
        }
      }, currentStyle)
    } else {
      return currentStyle
    }
  },
  htmlToEntity(nodeName, node) {
    if (nodeName === 'a') {
      return Entity.create(
        'LINK',
        'MUTABLE',
        { url: node.href }
      )
    }
  }
})

export const makeConverters = styleMap => ({
  toHTML: toHTML(styleMap),
  fromHTML: fromHTML(styleMap)
})



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/convert.js